export default "__VITE_ASSET__DMzPXQVR__"